var map = {
	"./social-500px.svg": 212,
	"./social-dribbble.svg": 213,
	"./social-facebook.svg": 214,
	"./social-github.svg": 215,
	"./social-google.svg": 216,
	"./social-instagram.svg": 217,
	"./social-odnoklassniki.svg": 218,
	"./social-reddit.svg": 219,
	"./social-stackoverflow.svg": 220,
	"./social-steam.svg": 221,
	"./social-twitch.svg": 222,
	"./social-twitter.svg": 223,
	"./social-vkontakte.svg": 224,
	"./social-windows.svg": 225,
	"./social-wordpress.svg": 226,
	"./social-yahoo.svg": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 211
// module chunks = 0